import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-action-modal',
    templateUrl: './confirm-action-modal.component.html',
    styles: [`
    h4, p {
      color: #1b3151;
    }
  `],
    standalone: false
})
export class ConfirmActionModalComponent implements OnInit {

  titel: string = 'Confirmar acción';
  message: string;
  acceptLabel = 'Aceptar';
  cancelLabel = 'Cancelar';
  acceptClass = 'btn btn-primary';
  cancelClass = 'btn btn-danger';

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

}
